import React from 'react'
import "./WholeLoader.scss";

const WholeLoader = () => {
    return (
        <div className='WholeLoader'>
            <div class="loader"></div>
        </div>
    )
}

export default WholeLoader